<div class="container-fluid bg">
    <div class="row brdr10" style="background: #f8f8f8 !important;">

        <!-- Header-->
        <div class="col-md-12 col-12 col-sm-12 padHeder" style="padding-bottom: 0; padding-right: 10px; margin-top: 15px;">
            <div class="col-md-10 col-10 pad0" style="display: inline-block;">
                <h4 style="display: inline-block; font-weight: 500; line-height: 1.2; color: #212529; font-size: 1.4rem;">{{objTaskData.task}}</h4>
                <span *ngIf="objTaskData.touserID != JrUserID" class="remider brdrRadius3" (click)="sendReminder();"
                style="margin-left: 10px; cursor: pointer;" title="Send Reminder"><i class="fa fa-bell"></i></span>
            </div>

            <div class="col-md-2 col-2 pad0" style="display: inline-block; text-align: right; vertical-align: top;">
                <span class="closeMdl" (click)="closeTaskModal('');"><i class="zmdi zmdi-close"></i></span>
            </div>
        </div>

        <!-- Body-->
        <div class="col-md-12 col-12 col-sm-12" style="margin: 10px 0px 15px;">
            <div>
                <!-- Target Date-->
                <span (click)="editDate(objTaskData.targetDT)" class="bz-orgBtn-lb" title="{{objTaskData.status == 2 ? 'Cancel Date' : objTaskData.status == 3 ? 'Done Date' : 'Target Date'}}" style="cursor: {{objTaskData.createduserID == JrUserID && (objTaskData.status == 0) ? 'pointer' : 'default'}}; overflow: hidden; display: inline-block; margin-right: 10px; font-size: 13px !important; padding: 5px 10px">
                    <i class="fa fa-calendar" style="margin-right: 5px;"></i> 
                    <span *ngIf="isDateLableShow">{{objTaskData.targetDT | todayTommorow}}</span>
                    <span *ngIf="(isDateLableShow && objTaskData.createduserID == JrUserID && (objTaskData.status == 0))"  style="margin-left: 10px; cursor: pointer;"><i class="fa fa-pencil"></i></span>
                    <span *ngIf="!isDateLableShow"> 
                        <input readonly [(ngModel)]="objTaskData.targetDT" [matDatepicker]="picker" [min]="minDate" (click)="picker.open()"
                         class="form-control fn13 orangeText"  tabindex="1"style="display: inline-block; width: 75px; height:18px ; background: #FFF; cursor: pointer;">
                        <mat-datepicker-toggle  matSuffix [for]="picker"
                        style="display: none; position: relative; top: 5px;"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </span> 
                    <span *ngIf="!isDateLableShow" (click)="saveNewDate()" style="margin-left: 10px; cursor: pointer;"><i class="fa fa-check"></i></span>
                </span>
                
                <!-- (click)="openChangeDate(DateChange)" -->
                <!-- Status-->
                <!-- <span class="yellowBadge" style="margin-right: 10px; overflow: hidden; display: inline-block;" title="Status">
                    <i class="fa fa-history" style="margin-right: 3px;"></i> {{objTaskData.status}}
                    <span style="margin-left: 10px; cursor: pointer;" (click)="openChangeStatus(statusChange)"><i class="fa fa-pencil"></i></span>
                </span> -->

                <!-- Executive-->
                <span (click)="openChangeExecutive(statusChange)" class="bz-orgBtn-lb" style="cursor: {{objTaskData.createduserID == JrUserID && (objTaskData.status == 0) ? 'pointer' : 'default'}}; display: inline-block; overflow: hidden; font-size: 13px !important; margin-right: 10px; padding: 5px 10px" title="Executive">
                    <i class="zmdi zmdi-account" style="margin-right: 6px;"></i>
                     <span>{{(JrUserID != objTaskData.createduserID ?  objTaskData.createdUserName : (JrUserID == objTaskData.touserID ? 'Me' : objTaskData.touserName))}}</span>
                    <span style="margin-left: 10px; cursor: pointer;" *ngIf="(objTaskData.createduserID == JrUserID && (objTaskData.status == 0))"><i class="fa fa-pencil"></i></span> 
                </span> 

                <!--Change Priority-->
                <span (click)="changePriority(objTaskData.priorityID)" class="bz-orgBtn-lb" style="cursor: {{objTaskData.createduserID == JrUserID && (objTaskData.status == 0) ? 'pointer' : 'default'}}; padding: {{!isPriority ? '0px 10px !important;' : '5px 10px'}}; display: inline-block; overflow: hidden; font-size: 13px !important;" title="Priority">
                    <i class="zmdi zmdi-time" style="margin-right: 4px;"></i>
                    <span *ngIf="isPriority">{{objTaskData.priorityID == 0 ? 'High Priority' : objTaskData.priorityID == 1 ? 'Normal Priority' : objTaskData.priorityID == 2 ? 'Low Priority': ''}}</span>
                    <span *ngIf="(isPriority && objTaskData.createduserID == JrUserID && (objTaskData.status == 0))" style="margin-left: 10px; cursor: pointer;"><i class="fa fa-pencil"></i></span>
                     <select *ngIf="!isPriority" class="form-control fn13 mobWdth mrgRight orangeText" [(ngModel)]="objTaskData.priorityID" style="cursor: pointer; display: inline-block; border-radius: 0px !important; width: 75%; border: none !important;">
                        <option value="0">High Priority</option>
                        <option value="1">Normal Priority</option>
                        <option value="2">Low Priority</option>
                     </select>
                    <span *ngIf="!isPriority" (click)="savePriority()" style="margin-left: 10px; cursor: pointer;"><i class="fa fa-check"></i></span> 
                </span> 

            </div>    
            <div class="bz-orgBtn-lb" style="font-size: 13px; line-height: 16px; padding: 7px 10px;" *ngIf="objTaskData.projectName || objTaskData.projectStageName">
                <span><i class="fa fa-align-left" style="margin-right: 5px;"></i>Project: </span>
                <span *ngIf="objTaskData.projectName">{{ objTaskData.projectName }}</span>
                <span *ngIf="objTaskData.projectName && objTaskData.projectStageName"> > </span>
                <span *ngIf="objTaskData.projectStageName">{{ objTaskData.projectStageName }}</span>  
            </div>
            <div style="padding-top: 10px; display: none;">
                <span class="label fn13 tealBadge {{objTaskData.status == 0 ? 'activeTeal' : ''}}"
                    style=" margin-left: 0px;margin-right: 5px;"><i class="fa fa-clock-o mrgri8" aria-hidden="true"></i>
                    <span >Pending</span></span>
                <span class="label fn13 blueBadge {{objTaskData.status == 1 ? 'activeBlue' : ''}}" 
                    style="margin-left: 5px;margin-right: 5px;"><i class="zmdi zmdi-pause mrgri8" aria-hidden="true"></i> 
                    <span>Pause</span></span>
                <span class="label fn13 darkBlueBadge {{objTaskData.status == 2 ? 'activedarkblue' : ''}}"
                    style="margin-left: 5px;margin-right: 5px;"><i class="fa fa-ban mrgri8" aria-hidden="true"></i>
                    <span>Cancelled</span></span>
                <span class="label fn13 greenBadge {{objTaskData.status == 3 ? 'activeGreen' : ''}}"
                    style="margin-left: 5px"><i class="fa fa-check mrgri8" aria-hidden="true"></i>
                    <span>Done</span></span>
            </div>    
            
            <!-- Tags -->
            <div style="margin-top: 0px; display: none;" *ngIf="objTaskData.tags.length > 0">
                <span class="blueBadge" style="margin: 10px 10px 0 0; padding: 5px 15px;" *ngFor="let t of objTaskData.tags">
                    {{t.name}}
                </span>
            </div>

            <!-- Details -->
            <div style="margin-top: 15px;">
                <div>
                    <h6 class="label-new" style="display: inline-block;color:#333; margin-bottom: 0px;">Details</h6><span style="margin-left: 10px; cursor: pointer;color: #15304A; font-size: 14px;" 
                    *ngIf="(objTaskData.createduserID == JrUserID && (objTaskData.status == 0))" (click)="openChangeDetail(changeDetail)"><i class="fa fa-pencil"></i></span>
                </div>
                <div style="font-size: 13px; display: inline-block;">
                    <div [innerText]="objTaskData.details ? objTaskData.details : '-'"></div>
                </div>
            </div>

             <!-- Status Notes -->
             <div style="margin-top: 15px;">
                <div>
                    <h6 class="label-new" style="display: inline-block;color: #333; margin-bottom: 0px;">Current Status</h6>                    
                </div>
                <div style="font-size: 13px;" *ngIf="(objTaskData.touserID == JrUserID && (objTaskData.status == 0 || objTaskData.status == 1))">
                    <textarea rows="4" [(ngModel)]="objTaskData.statusNote" style="resize: none;border-color: #BCC2C9;" class="txtArea brdrRadius3" maxlength="500"></textarea>
                </div>
                <div style="font-size: 13px;" [hidden]="(objTaskData.touserID == JrUserID && (objTaskData.status == 0 || objTaskData.status == 1))">
                    <span>{{objTaskData.statusNote ? objTaskData.statusNote : '-'}}</span>
                </div>
            </div>
            <!-- Task Completed Image -->
            <div style="margin-top: 15px;" *ngIf="objTaskData.status == 3 && taskDoneImageVal != ''">
                <div>
                    <h6 class="label-new" style="display: inline-block;color: #333; margin-bottom: 0px;">Completion
                        Attachment
                    </h6>
                </div>
                <div *ngIf="objTaskData.status == 3">
                    <a href="{{imageLink}}" target="_blank" *ngIf="isImage">
                        <img src="{{imageLink}}" style="width: 200px;" alt=""></a>
                        <a href="{{imageLink}}" *ngIf="!isImage" style="text-decoration: underline; font-size: 13px; color: #333; padding-left: 3px;" target="_blank">View Document</a>
                </div>
            </div>
            <!-- Change Status -->
            <div *ngIf="objTaskData.touserID == JrUserID && objTaskData.createduserID == JrUserID" class="col-md-12" style="margin-top: 15px; display: inline-block;padding: 0px;">
            <!--Task for me button hide show-->
                <!--Pendding-->
                <div class="webView" *ngIf="objTaskData.status == 0">
                    <span (click)="taskUpdate(0)" class="btn btn-darkGreen brdrRadius3" style="line-height: 30px; font-size: 13px; padding: 0 12px;">
                        <i class="fa fa-floppy-o" aria-hidden="true" style="margin-right: 5px;"></i> Update
                    </span>
                    <span style="padding: 0px;cursor: pointer;">
                        <span  (click)="isGGL ? openTaskDoneModal(taskDoneImageUpload) : changeStatus(3,3)" class="btn btn-darkGreen brdrRadius3" style="margin-left: 10px; line-height: 30px; font-size: 13px; padding: 0 12px;">
                            <i class="fa fa-check" style="margin-right: 5px;"></i> Complete
                        </span>
                    </span>
                    <span style="padding: 0px;cursor: pointer;">
                        <span (click)="changeStatus(1, 10)" class="btn btn-darkBlue brdrRadius3" style="margin-left: 10px; line-height: 30px; font-size: 13px; padding: 0 12px;">
                            <i class="zmdi zmdi-pause" style="margin-right: 5px;"></i> Pause
                        </span>
                    </span>
                    <span style="padding: 0px;cursor: pointer;">
                        <span (click)="changeStatus(2, 2)" class="btn btn-darkBlue brdrRadius3" style="margin-left: 10px; line-height: 30px; font-size: 13px; padding: 0px 12px; height: 32px;">
                            <i class="fa fa-ban" style="margin-right: 5px;"></i> Cancel
                        </span>
                    </span> 
                </div>

                
                <div class="mobView" *ngIf="objTaskData.status == 0">
                    <div style="display: flex; flex-wrap: wrap; gap: 8px;">
                        <div *ngIf="objTaskData.status == 0">
                            <span (click)="taskUpdate(0)" class="btn btn-darkGreen brdrRadius3" style="line-height: 30px; font-size: 13px; padding: 0 12px;">
                                <i class="fa fa-floppy-o" aria-hidden="true" style="margin-right: 5px;"></i> Update
                            </span>
                        </div>
                        <div style="padding: 0px;cursor: pointer;">
                            <span  (click)="isGGL ? openTaskDoneModal(taskDoneImageUpload) : changeStatus(3,3)" class="btn btn-darkGreen brdrRadius3" style="line-height: 30px; font-size: 13px; padding: 0 12px;">
                                <i class="fa fa-check" style="margin-right: 5px;"></i> Complete
                            </span>
                        </div>
                        <div style="padding: 0px;cursor: pointer;">
                            <span (click)="changeStatus(1, 1)" class="btn btn-darkBlue brdrRadius3" style="line-height: 30px; font-size: 13px; padding: 0 12px;">
                                <i class="zmdi zmdi-pause" style="margin-right: 5px;"></i> Pause
                            </span>
                        </div>
                        <div style="padding: 0px;cursor: pointer;">
                            <span (click)="changeStatus(2, 2)" class="btn btn-darkBlue brdrRadius3" style="line-height: 30px; font-size: 13px; padding: 0px 12px;">
                                <i class="fa fa-ban" style="margin-right: 5px;"></i> Cancel
                            </span>
                        </div> 
                    </div>
                </div>


                <!--Paused-->
                <div class="webView" *ngIf="objTaskData.status == 1">
                    <span (click)="taskUpdate(0)" class="btn btn-darkGreen brdrRadius3" style="line-height: 30px; font-size: 13px; padding: 0 12px;">
                        <i class="fa fa-floppy-o" aria-hidden="true" style="margin-right: 5px;"></i> Update
                    </span>
                    <span style="padding: 0px;cursor: pointer;">
                        <span  (click)="isGGL ? openTaskDoneModal(taskDoneImageUpload) : changeStatus(3,3)" class="btn btn-darkGreen brdrRadius3" style="margin-left: 10px; line-height: 30px; font-size: 13px; padding: 0 12px;">
                            <i class="fa fa-check" style="margin-right: 5px;"></i> Complete
                        </span>
                    </span>
                    <span style="padding: 0px;cursor: pointer;">
                        <span (click)="changeStatus(0, 8)" class="btn btn-darkBlue brdrRadius3" style="margin-left: 10px; line-height: 30px; font-size: 13px; padding: 0 12px;">
                            <i class="fa fa-refresh" style="margin-right: 5px;"></i> Resume
                        </span>
                    </span>
                    <span style="padding: 0px;cursor: pointer;">
                        <span (click)="changeStatus(2, 2)" class="btn btn-darkBlue brdrRadius3" style="margin-left: 10px; line-height: 30px; font-size: 13px; padding: 0px 12px;">
                            <i class="fa fa-ban" style="margin-right: 5px;"></i> Cancel
                        </span>
                    </span> 
                </div>

                
                <div class="mobView" *ngIf="objTaskData.status == 1">
                    <div style="display: flex; flex-wrap: wrap; gap: 8px;">
                        <div>
                            <span (click)="taskUpdate(0)" class="btn btn-darkGreen brdrRadius3" style="line-height: 30px; font-size: 13px; padding: 0px 12px;">
                                <i class="fa fa-floppy-o" aria-hidden="true" style="margin-right: 5px;"></i> Update
                            </span>
                        </div>
                        <div style="padding: 0px;cursor: pointer;">
                            <span  (click)="isGGL ? openTaskDoneModal(taskDoneImageUpload) : changeStatus(3,3)" class="btn btn-darkGreen brdrRadius3" style="line-height: 30px; font-size: 13px; padding: 0 12px;">
                                <i class="fa fa-check" style="margin-right: 5px;"></i> Complete
                            </span>
                        </div>
                        <div style="padding: 0px;cursor: pointer;">
                            <span (click)="changeStatus(0, 8)" class="btn btn-darkBlue brdrRadius3" style="line-height: 30px; font-size: 13px; padding: 0 12px;">
                                <i class="fa fa-refresh" style="margin-right: 5px;"></i> Resume
                            </span>
                        </div>
                        <div style="padding: 0px;cursor: pointer;">
                            <span (click)="changeStatus(2, 2)" class="btn btn-darkBlue brdrRadius3" style="line-height: 30px; font-size: 13px; padding: 0px 12px;">
                                <i class="fa fa-ban" style="margin-right: 5px;"></i> Cancel
                            </span>
                        </div> 
                    </div>
                </div>

                <!--Cancel & Done-->
                <div *ngIf="objTaskData.status == 2 || objTaskData.status == 3">
                    <span (click)="changeStatus(0, 9)" class="btn btn-darkBlue brdrRadius3" style="line-height: 30px; font-size: 13px; padding: 0 12px;">
                        <i class="fa fa-check" style="margin-right: 5px;"></i> Reopen
                    </span>
                </div>
            </div>   
           
            <div *ngIf="objTaskData.touserID == JrUserID && objTaskData.createduserID != JrUserID" class="col-md-12" style="margin-top: 15px; display: inline-block;padding: 0px;">
                <!--Pendding-->
                <div *ngIf="objTaskData.status == 0">
                    <span  (click)="taskUpdate(0)" class="btn btn-darkGreen brdrRadius3" style="line-height: 30px; font-size: 13px; padding: 0 12px;">
                        <i class="fa fa-floppy-o" aria-hidden="true" style="margin-right: 5px;"></i> Update
                    </span>
                    <span style="padding: 0px;cursor: pointer;">
                        <span  (click)="isGGL ? openTaskDoneModal(taskDoneImageUpload) : changeStatus(3,3)" class="btn btn-darkGreen brdrRadius3" style="margin-left: 10px; line-height: 30px; font-size: 13px; padding: 0 12px;">
                            <i class="fa fa-check" style="margin-right: 5px;"></i> Complete
                        </span>
                    </span>
                </div>
                <!--Paused-->
                <div *ngIf="objTaskData.status == 1">
                    <span  (click)="taskUpdate(0)" class="btn btn-darkGreen brdrRadius3" style="line-height: 30px; font-size: 13px; padding: 0 12px;">
                        <i class="fa fa-check" style="margin-right: 5px;"></i> Update
                    </span>
                </div>
                <!--Cancel & Done-->
                <!-- <div *ngIf="objTaskData.status == 2 || objTaskData.status == 3">
                    <span (click)="changeStatus(0)" class="btn btn-darkBlue" style="line-height: 30px; font-size: 13px; padding: 0 12px;">
                        <i class="fa fa-check" style="margin-right: 5px;"></i> Reopen
                    </span>
                </div> -->
            </div>  
            
            <!--Task for delegated button hide show-->
            <div *ngIf="objTaskData.touserID != JrUserID && objTaskData.createduserID == JrUserID" class="col-md-12" style="margin-top: 15px; display: inline-block;padding: 0px;">
                <!--Pendding-->
                <div *ngIf="objTaskData.status == 0" style="display: flex; flex-wrap: wrap; gap: 8px;">
                    <!-- <span style="padding: 0px;cursor: pointer;">
                        <span  (click)="taskUpdate(0)" class="btn btn-blue" style="line-height: 30px; font-size: 13px; padding: 0 12px;">
                            <i class="fa fa-check" style="margin-right: 5px;"></i> Update
                        </span>
                    </span> -->
                    <div style="padding: 0px;cursor: pointer;">
                        <span  (click)="isGGL ? openTaskDoneModal(taskDoneImageUpload) : changeStatus(3,3)" class="btn btn-darkGreen brdrRadius3" style="line-height: 30px; font-size: 13px; padding: 0 12px;">
                            <i class="fa fa-check" style="margin-right: 5px;"></i> Complete
                        </span>
                    </div>
                    <div style="padding: 0px;cursor: pointer;">
                        <span (click)="changeStatus(1, 3)" class="btn btn-darkBlue brdrRadius3" style="line-height: 30px; font-size: 13px; padding: 0 12px;">
                            <i class="zmdi zmdi-pause" style="margin-right: 5px;"></i> Pause
                        </span>
                    </div>
                    <div style="padding: 0px;cursor: pointer;">
                        <span (click)="changeStatus(2, 2)" class="btn btn-darkBlue brdrRadius3" style="line-height: 30px; font-size: 13px; padding: 0px 12px;">
                            <i class="fa fa-ban" style="margin-right: 5px;"></i> Cancel
                        </span>
                    </div> 
                </div>

                <!--Paused-->
                <div *ngIf="objTaskData.status == 1">
                    <div style="display: flex; flex-wrap: wrap; gap: 8px;">
                        <div style="padding: 0px;cursor: pointer;">
                            <span  (click)="isGGL ? openTaskDoneModal(taskDoneImageUpload) : changeStatus(3,3)" class="btn btn-darkGreen brdrRadius3" style="line-height: 30px; font-size: 13px; padding: 0 12px;">
                                <i class="fa fa-check" style="margin-right: 5px;"></i> Complete
                            </span>
                        </div>
                        <div style="padding: 0px;cursor: pointer;">
                            <span  (click)="changeStatus(0, 8)" class="btn btn-darkBlue brdrRadius3" style="line-height: 30px; font-size: 13px; padding: 0 12px;">
                                <i class="fa fa-refresh" style="margin-right: 5px;"></i> Resume
                            </span>
                        </div> 
                        <div style="padding: 0px;cursor: pointer;">
                            <span (click)="changeStatus(2, 2)" class="btn btn-darkBlue brdrRadius3" style="line-height: 30px; font-size: 13px; padding: 0px 12px;">
                                <i class="fa fa-ban" style="margin-right: 5px;"></i> Cancel
                            </span>
                        </div> 
                    </div>
                </div>

                <!--Cancel & Done-->
                <div *ngIf="objTaskData.status == 2 || objTaskData.status == 3 brdrRadius3">
                    <span style="padding: 0px;cursor: pointer;">
                        <span  (click)="changeStatus(0, 9)" class="btn btn-darkGreen brdrRadius3" style="margin-right: 5px;line-height: 30px; font-size: 13px; padding: 0px 12px;">
                            <i class="fa fa-refresh" style="margin-right: 5px;"></i> Reopen
                        </span>
                    </span> 
                </div>
            </div>
        </div>
    </div>    
</div>

<!-- Executive Change -->
<ng-template #changeExecutive let-modal>
    <!--Header-->
    <div class="col-md-12 col-sm-12 col-12 mobAddLed">
        <div class="row">
            <div class="col-md-10 col-sm-10 col-10" style="padding-left: 0px;padding: 15px;">
                <h4 class="modal-title"><span id="ApntmntHdr">Assign to</span></h4>
            </div>
            <div class="col-md-2 col-sm-2 col-2" style="padding: 15px;">
                <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="modal.dismiss('Cross click')"></i>
            </div>
        </div>
    </div>
    <!--Body-->
    <div class="col-md-12 col-sm-12 col-12 mobAddLed">
        <div class="row" style="margin-bottom: 15px;">
            <div class="col-md-12 col-sm-12 col-12">
                <div>
                    <select class="form-control" style="cursor: pointer; padding: 0;">
                        <option value="0">Assign to</option>
                        <option value="{{u.UserID}}" *ngFor="let u of userList | sort : 'Name' : 0">{{u.Name}}</option>
                    </select>
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-12" style="margin-top: 10px;"> 
                <div class="btn btn-blue" 
                    style="font-size: 13px; padding: 0 15px; line-height: 30px; cursor: pointer;">
                    <i class="fa fa-check" style="margin-right: 5px;"></i> Save
                </div>
            </div>
        </div>

    </div>
</ng-template>

<!-- Assign to Executive Change -->
<ng-template #statusChange let-modal>
    <!--Header-->
        <div class="col-md-12 col-sm-12 col-12">
            <div class="row">
                <div class="col-md-10 col-sm-10 col-10" style="padding: 15px 15px 10px 15px;">
                    <h4 class="modal-title"><span style="font-size: 20px;">Assign to</span></h4>
                </div>
                <div class="col-md-2 col-sm-2 col-2" style="padding: 15px 15px 10px 15px;">
                    <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="modal.dismiss('Cross click')"></i>
                </div>
            </div>
        </div>
        <!--Body-->
        <!-- Search User -->
        <div *ngIf="userList.length > 8" class="input-icons search" style="display: inline-block; float: right; width: 100%;">
            <span class="fa fa-search"></span>
            <input class=" formCtlFltr form-control brdrRadius3" [(ngModel)]="search" placeholder="Search" 
            style="text-align: left; margin-right: 10px; display: inline-block; padding-left: 35px !important; padding: 2px; box-shadow: none; width: 88%; font-size: 13px; height: 34.4px;"
            type="text">
        </div>
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px;
        padding-bottom: 20px;">       
           <div class="scroll">
             <div class="{{changeColorUserList(i % 7, U.UserID)}} brdrRadius3" *ngFor="let U of userList | filter:'Name':search | sort : 'Name' : 0,let i = index" style="padding-top: 10px;padding: 0px 3px !important;margin-bottom: 10px;display: inherit;">
                <div (click)="selectExeChane(U.UserID)" style="width: 100%; font-size: 13px; line-height: 31px; text-align: center;cursor: pointer;">{{U.Name}}</div>     
             </div>
           </div>
        </div>
</ng-template>

<!-- Detail Change -->
<ng-template #changeDetail let-modal>
    <!--Header-->
    <div class="col-md-12 col-sm-12 col-12">
        <div class="row">
            <div class="col-md-10 col-sm-10 col-10" style="padding-left: 0px;padding: 10px 0px 0px 15px;">
                <h4 class="modal-title"><span style="font-size: 20px;">Edit Details </span></h4>
            </div>
            <div class="col-md-2 col-sm-2 col-2" style="padding-top: 15px;">
                <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="modal.dismiss('Cross click')"></i>
            </div>
            <div class="col-md-12 col-sm-12 col-12 inLneBlk pdng" style=" text-align: left;margin-bottom: 15px;">
                <textarea class="txtArea fn13 brdrRadius3" placeholder="Details" maxlength="250" style="height: 20vh;resize: none; margin-top: 10px;" [(ngModel)]="isEditDetails"></textarea>
            </div>

            <div class="col-md-12 col-sm-12 col-12" style="margin-bottom: 15px;"> 
                <div class="btn btn-darkGreen brdrRadius3" (click)="editDetailsnotes()"
                    style="font-size: 13px; padding: 5px 8px; line-height: 18px; cursor: pointer;">
                    <i class="fa fa-check" style="margin-right: 5px;"></i> Save
                </div>
            </div>
        </div>
    </div>
    <!--Body-->
    <!-- <div style="font-size: 13px;">
        <textarea rows="4" [(ngModel)]="isEditDetails" style="resize: none;" class="txtArea"></textarea>
    </div> -->
           

            <!-- <div class="col-md-12 col-sm-12 col-12" style="margin-bottom: 15px;"> 
                <div class="btn btn-darkGreen" (click)="editDetailsnotes()"
                    style="font-size: 13px; padding: 0 10px; line-height: 30px; cursor: pointer;">
                    <i class="fa fa-check" style="margin-right: 5px;"></i> Save
                </div>
            </div> -->

</ng-template>

<!-- Upload Task Done Image -->
<ng-template #taskDoneImageUpload let-modal>
    <!--Header-->
    <div class="col-md-12 col-sm-12 col-12">
        <div class="row">
            <div class="col-md-10 col-sm-10 col-10" style="padding-left: 0px;padding: 10px 0px 0px 15px;">
                <h4 class="modal-title"><span style="font-size: 20px;">Complete Task </span></h4>
                <p style="color: gray; font-size: 13px; position: relative; top: -3px; margin-bottom: 0px;">Upload an attachment of the completed task.</p>
            </div>
            <div class="col-md-2 col-sm-2 col-2" style="padding-top: 15px;">
                <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="modal.dismiss('Cross click')"></i>
            </div>
            <div class="col-md-12 col-sm-12 col-12 inLneBlk pdng" style=" text-align: left;margin-bottom: 15px;">
                <div class="col-md-12 col-sm-12 col-xs-12 pad0" style="margin-top: 10px;">
                    <span class="btn font13 lableBtnOrange padLeft5 brdrRadius3 hvrInfo btnBottom"
                        style="width: fit-content; padding: 5px 12px" (click)="addAttechmentFile()" *ngIf="!fileName">
                        <i class="zmdi zmdi-file-plus" style="padding-right: 10px;"></i>Upload
                    </span>
                    <input type="file" id="addAttechment" fileread="fileUpload.val"
                        (change)="handleFileInput($event.target.files)" style="display: none;">
                    <img id="addAttechmentPreview" *ngIf="showImage" [src]="fileData" alt="" style="width: 200px;">
                    <div>
                        <span *ngIf="!showImage" style="font-size: 14px; color: #333; text-decoration: none;">{{fileName}}</span>
                    </div>
                    <div *ngIf="fileName" (click)="removeAttechUploadedFile()" style="margin-top: 15px;">
                        <div style="display: flex; gap: 10px; align-items: center;">
                            <span class="lable-BtnDarkBLue brdrRadius3" style="cursor: pointer; border-radius: 3px; padding: 6px 12px !important; display: inline-flex; align-items: center; height: 34px; font-size: 13px;">
                                <i class="fa fa-trash" style="margin-right: 5px; font-size: 13px;"></i>Remove
                            </span>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-12" style="margin-bottom: 15px;">
                <div class="btn btn-darkGreen brdrRadius3" (click)="saveTaskDoneImage()"
                    style="font-size: 13px; padding: 5px 8px; line-height: 18px; cursor: pointer;">
                    <i class="fa fa-check" style="margin-right: 5px;"></i> Complete
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #taskDoneModal let-modal>
    <!--Header-->
    <div class="col-md-12 col-sm-12 col-12">
        <div class="row" style="flex-direction: column; background-color: white; border-radius: 10px;">
            <div class="col-md-12" style="margin-top: 40px; display: flex; justify-content: center; margin-bottom: 30px;">
                <img src="https://biziverse.com/ERP/assets/images/done%20invoice.gif" style="width: 185px;" />
            </div>
            <div style="text-align: center; padding: 0px; font-size: 25px; margin-top: 5px; position: relative;
top: -36px;">
                <span class="" style="color: #e88421;">Task Done!</span>
            </div>
            <div class="" style="text-align: center; padding: 0px; position: absolute; right: 5px; top: 5px;">
                <span style="float: right; display: inline-block;" (click)="closeTaskModal('Done')">
                    <i class="closeMdl zmdi zmdi-close" data-dismiss="modal" style="margin-top: 0px; margin-left: 10px; padding: 6px 10px !important; top: 3px; right: 8px;"></i>
                </span>
            </div>
        </div>
    </div>
</ng-template>

<!-- Upload Task Done Alert -->
<ng-template #taskDoneAlert let-modal>
    <!--Header-->
    <div class="col-md-12 col-sm-12 col-12">
        <div class="row">
            <div class="col-md-10 col-sm-10 col-10" style="padding-left: 0px;padding: 10px 0px 0px 15px;">
                <h4 class="modal-title"><span style="font-size: 20px;">Complete Task </span></h4>
                <p style="color: gray; font-size: 13px; position: relative; top: -3px; margin-bottom: 0px;">Upload an attachment of the completed task.</p>
            </div>
            <div class="col-md-2 col-sm-2 col-2" style="padding-top: 15px;">
                <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="modal.dismiss('Cross click')"></i>
            </div>
            <div class="col-md-12 col-sm-12 col-12 inLneBlk pdng" style=" text-align: left;margin-bottom: 15px;">
                <div class="col-md-12 col-sm-12 col-xs-12 pad0" style="margin-top: 10px;">
                    <span class="btn font13 lableBtnOrange padLeft5 brdrRadius3 hvrInfo btnBottom"
                        style="width: fit-content; padding: 5px 12px" (click)="addAttechmentFile()" *ngIf="!fileName">
                        <i class="zmdi zmdi-file-plus" style="padding-right: 10px;"></i>Upload
                    </span>
                    <input type="file" id="addAttechment" fileread="fileUpload.val"
                        (change)="handleFileInput($event.target.files)" style="display: none;">
                    <img id="addAttechmentPreview" *ngIf="showImage" [src]="fileData" alt="" style="width: 200px;">
                    <div>
                        <span *ngIf="!showImage" style="font-size: 14px; color: #333; text-decoration: none;">{{fileName}}</span>
                    </div>
                    <div *ngIf="fileName" (click)="removeAttechUploadedFile()" style="margin-top: 15px;">
                        <div style="display: flex; gap: 10px; align-items: center;">
                            <span class="lable-BtnDarkBLue brdrRadius3" style="cursor: pointer; border-radius: 3px; padding: 6px 12px !important; display: inline-flex; align-items: center; height: 34px; font-size: 13px;">
                                <i class="fa fa-trash" style="margin-right: 5px; font-size: 13px;"></i>Remove
                            </span>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-12" style="margin-bottom: 15px;">
                <div class="btn btn-darkGreen brdrRadius3" (click)="saveTaskDoneImage()"
                    style="font-size: 13px; padding: 5px 8px; line-height: 18px; cursor: pointer;">
                    <i class="fa fa-check" style="margin-right: 5px;"></i> Complete
                </div>
            </div>
        </div>
    </div>
</ng-template>


<ngx-spinner color="rgb(232, 132, 33)" size="default" type="ball-clip-rotate">

</ngx-spinner>
